// auth
const LOGIN = `/business/login`;

const VERIFY_OTP = `/business/otp_verify`;

// profile
const GET_PROFILE = `/business/profile_data`;

const UPDATE_PROFILE = `/business/update_profile_info`;

// employees
const GET_EMPLOYEES = (id) => `/business/get_employees/${id}`;

const UPDATE_EMPLOYEE = `/business/update_employee`;

const CREATE_EMPLOYEE = "/business/create_employee";

const DELETE_EMPLOYEE = (id) => `/business/delete_employee/${id}`;

// services
const GET_ALL_SERVICES = `/services/get_all_business_services`;

const GET_SERVICES = (id) => `/services/get_services/${id}`;

const GET_SERVICE_BY_ID = (id) => `/services/get_details/${id}`;

const CREATE_SERVICE = "/services/create";

const UPDATE_SERVICE = "/services/update";

const DELETE_SERVICE = (id) => `/services/delete/${id}`;

// appointments
const GET_APPOINTMENTS = "/appointment/appointments";

const GET_EMPLOYEE_APPOINTMENTS = "/appointment/employee_appointments";

const CREATE_APPOINTMENT = "/appointment/create";

// customers
const GET_CLIENTS = (page, size, type, search) =>
  `/users/get_clients?page=${page}&size=${size}&type=${type}&search=${search}`;

const GET_CLIENT_HISTORY = "/appointment/user_appointments";

const DELETE_CLIENT = "/users/delete_business_client";

const GET_CLIENT_BY_ID = (id) => `/users/getClient/${id}`;

const CREATE_CLIENT = "/business/add_user_in_list";

const GET_CLIENT_STATS = (id) => `/users/get_client_stats/${id}`;

// employee schedule
const GET_TIMESLOTS = "/schedule/get_timeslots";

const GET_SCHEDULE = (id) => `/schedule/get_schedule/${id}`;

const CREATE_SCHEDULE = "/schedule/create";

const SEND_REMINDER = "/appointment/send_reminder_to_client";

const ADD_COMMENT = "/appointment/update";

const CANCEL_APPOINTMENT = "/appointment/cancel";

const RESCHEDULE_APPOINTMENT = "/appointment/reschedule";

// plans
const GET_ALL_PLANS = "/servicePlans/getAll";

const GET_USER_PLANS = "/servicePlans/getAllAssignedPlansOfClient";

const ASSIGN_PLANS = "/servicePlans/assignServicePlanToClient";

const FREEZE_UNFREEZE_PLAN = "/servicePlans/freezeUnfreezeUserServicePlan";

const CANCEL_MEMBERSHIP = "/servicePlans/deassignServicePlanFromClient";

const RENEW_SUBSCRIPTION_PLAN = (id) => `/servicePlans/renewUserServicePlan/${id}`;

const RENEW_CARD_PLAN = (id) => `/servicePlans/renewOneTimeUserServicePlan/${id}`;

const DELETE_PLAN = (id) => `/servicePlans/deleteServicePlan/${id}`;

const CREATE_PLAN = "/servicePlans/create";

// notifications
const SEND_POPUP = "/business/sendPopUp";

const RESET_POPUP = "/business/resetPopUp";

const SEND_NOTIFICATION = "/appointment/sendMessage";

const SEND_NOTIFICATION_TO_ALL = "/appointment/sendMessageToAll";

const GET_NOTIFICATIONS = "/notifications/getAllBusinessEmployeeNotifications";

const GET_UNREAD_NOTIFICATIONS_COUNT = "/notifications/getUnreadNotificationsCount";

const MARK_AS_READ_NOTIFICATIONS =
  "/notifications/markAllBusinessNotificationsAsRead";

// subscription
const GET_SUBSCRIPTION_DETAILS = "/business/planConsumptionInfo";

const GET_SUBSCRIPTION_PLANS = "/plan/getAll";

const GET_SUBSCRIPTION_PLAN_PRICE = "/plan/getPlanNormalizedPrice";

const SUBSCRIBE_TO_PLAN = "/plan/subscribe";

const CANCEL_SUBSCRIPTION = "/plan/cancelSubscription";

const CHECK_SUBSCRIPTION = "/business/getIsPaymentOption";

// invoices
const GET_INVOICES = "/plan/getPaymentHistory";

const SEND_INVOICES = "/plan/sendInvoiceToEmail";

// statistics
const GET_STATISTICS = "/business/statistics";

// class
const GET_EMPLOYEE_APPOINTMENT_HISTORY = "/appointment/employee_appointments";

const GET_PARTICIPANTS_OF_CLASS = (id) =>
  `/appointment/appointmentParticipants/${id}`;

const MARK_ATTENDANCE = "/appointment/markAttendance";

// waiting list
const GET_WAITING_LIST_CLIENTS = (id) =>
  `/business/get-waiting-list-clients/${id}`;

const REMOVE_FROM_WAITING_LIST = "/business/remove_from_waiting_list";

// export
const EXPORT = "/appointment/appointmentsReport";

// coupons
const GET_COUPONS = (page, size) => `/coupon?page=${page}&size=${size}`;

const CREATE_COUPON = "/coupon/create";

const COUPON_BY_ID = (id) => `/coupon/${id}`;

const GET_COUPONS_USAGE_HISTORY = (page, size) =>
  `/coupon/usage_history?page=${page}&size=${size}`;

// gift cards
const GET_GIFT_CARDS = (page, size) => `/gift-card?page=${page}&size=${size}`;

const GET_GIFT_CARD_PURCHASE_HISTORY = (page, size) =>
  `/gift-card/purchase-history?page=${page}&size=${size}`;

const GET_GIFT_CARD_CONSUMPTION_HISTORY = (page, size) =>
  `/gift-card/consumption-history?page=${page}&size=${size}`;

const GET_GIFT_CARD_CONSUMPTION_HISTORY_BY_CODE = (id) =>
  `/gift-card/consumption_history/${id}`;

const CREATE_GIFT_CARD = "/gift-card/create";

const GIFT_CARD_BY_ID = (id) => `/gift-card/${id}`;

// message log
const GET_MESSAGE_LOG = (page, limit) => `/message-log/list?page=${page}&limit=${limit}`;

// message templates
const GET_MESSAGE_TEMPLATES   = "/message-templates/get";
const CREATE_MESSAGE_TEMPLATE = "/message-templates/create";
const UPDATE_MESSAGE_TEMPLATE = (id) => `/message-templates/update/${id}`;
const DELETE_MESSAGE_TEMPLATE = (id) => `/message-templates/delete/${id}`;
const TOGGLE_MESSAGE_TEMPLATE = (id) => `/message-templates/toggle/${id}`;

// forms
const GET_FORMS = (type) => `/forms${type ? `?type=${type}` : ""}`;
const GET_FORM = (id) => `/forms/${id}`;
const CREATE_FORM = "/forms";
const UPDATE_FORM = (id) => `/forms/${id}`;
const DELETE_FORM = (id) => `/forms/${id}`;
const TOGGLE_FORM = (id) => `/forms/${id}/toggle`;
const SEND_FORM_LINK = "/forms/send-link";
const GET_FORM_SUBMISSIONS = (id, page, limit) => `/forms/${id}/submissions?page=${page}&limit=${limit}`;
const GET_FORM_SUBMISSION = (formId, submissionId) => `/forms/${formId}/submissions/${submissionId}`;
const GET_FORM_LINKS = (id) => `/forms/${id}/links`;
const GET_CLIENT_FORM_LINKS = (clientId) => `/forms/client/${clientId}/links`;
const GET_FORM_SUBMISSION_PRINT = (formId, submissionId) => `/forms/${formId}/submissions/${submissionId}/print`;
const FORM_RESIGN_ALL = (id) => `/forms/${id}/resign-all`;
const FORM_BULK_SEND = (id) => `/forms/${id}/bulk-send`;
const FORM_ALL_LINKS = `/forms/all-links`;
const FORM_SUBMISSION_NOTES = (formId, submissionId) =>
  `/forms/${formId}/submissions/${submissionId}/notes`;
const FORM_SUBMISSION_NOTE_DELETE = (formId, submissionId, noteId) =>
  `/forms/${formId}/submissions/${submissionId}/notes/${noteId}`;

// client documents
// NOTE: backend paths come from src/routes/v1/assets.route.js. They were
// previously stubbed with the wrong names ("getSignedS3UploadURL" /
// "deleteClientDocument") which would 404 if anything tried to call them.
// Real names: createSignedUploadURL (POST), saveClientDocuments (POST),
// getClientDocuments (POST), deleteOne (PUT).
const ASSETS_CREATE_SIGNED_UPLOAD_URL = "/assets/createSignedUploadURL";
const ASSETS_SAVE_CLIENT_DOCUMENTS = "/assets/saveClientDocuments";
const ASSETS_GET_CLIENT_DOCUMENTS = "/assets/getClientDocuments";
const ASSETS_DELETE_CLIENT_DOCUMENT = "/assets/deleteOne";

// Payment Requests
const LIST_PAYMENT_REQUESTS = "/payment-requests";
const CREATE_PAYMENT_REQUEST = "/payment-requests";
const GET_PAYMENT_REQUEST = (id) => `/payment-requests/${id}`;
const CANCEL_PAYMENT_REQUEST = (id) => `/payment-requests/${id}/cancel`;
const RESEND_PAYMENT_REQUEST = (id) => `/payment-requests/${id}/resend`;

// Reviews
const GET_REVIEWS_MANAGE = "/reviews/manage";
const GET_REVIEWS_STATS = "/reviews/stats";
const TOGGLE_HIDE_REVIEW = (id) => `/reviews/toggle-hide/${id}`;

// Automations
const GET_AUTOMATIONS = "/automations/get";
const GET_TEMPLATES = "/automations/templates";
const CREATE_FROM_TEMPLATE = "/automations/create-from-template";
const CREATE_AUTOMATION = "/automations/create";
const UPDATE_AUTOMATION = (id) => `/automations/update/${id}`;
const DELETE_AUTOMATION = (id) => `/automations/delete/${id}`;
const TOGGLE_AUTOMATION = (id) => `/automations/toggle/${id}`;
const GET_AUTOMATION_RUNS = (id) => `/automations/runs/${id}`;

// Appointment Requests
const GET_APPOINTMENT_REQUESTS = "/appointment/get-all-appointment-requests";
const RESPOND_APPOINTMENT_REQUEST = (id) => `/appointment/respond-to-appointment-request/${id}`;
const GET_APPOINTMENT_REQUESTS_HISTORY = "/appointment/get-appointment-requests-history";

// Service Categories
const GET_SERVICE_CATEGORIES = "/service-categories";
const CREATE_SERVICE_CATEGORY = "/service-categories/create";

// Products
const GET_ALL_PRODUCTS = "/business/get_product/";
const ADD_PRODUCT = "/business/add_product/";
const EDIT_PRODUCT = (id) => `/business/edit_product/${id}`;
const DELETE_PRODUCT = (id) => `/business/delete_product/${id}`;

// Schedule Override (temporary working hours)
const GET_SCHEDULE_OVERRIDES = (employeeId) => `/schedule/get_scheduleOverrides/${employeeId}`;
const CREATE_SCHEDULE_OVERRIDE = "/schedule/scheduleOverride";
const CREATE_SCHEDULE_OVERRIDE_RANGE = "/schedule/scheduleOverrideRange";
const DELETE_SCHEDULE_OVERRIDE = (id) => `/schedule/scheduleOverride/${id}`;
const CHECK_SCHEDULE_OVERRIDE_CONFLICTS = "/schedule/scheduleOverride/conflicts";

// Reminders
const PARSE_REMINDER = '/ai/parse-reminder';
const REMINDERS_LIST = '/reminders';
const REMINDERS_TRIGGERED = '/reminders/triggered';
const REMINDERS_CREATE = '/reminders/create';
const REMINDERS_UPDATE = (id) => `/reminders/${id}`;
const REMINDERS_COMPLETE = (id) => `/reminders/${id}/complete`;
const REMINDERS_SNOOZE = (id) => `/reminders/${id}/snooze`;
const REMINDERS_DELETE = (id) => `/reminders/${id}`;

export {
  LOGIN,
  GET_MESSAGE_LOG,
  GET_MESSAGE_TEMPLATES,
  CREATE_MESSAGE_TEMPLATE,
  UPDATE_MESSAGE_TEMPLATE,
  DELETE_MESSAGE_TEMPLATE,
  TOGGLE_MESSAGE_TEMPLATE,
  RESCHEDULE_APPOINTMENT,
  VERIFY_OTP,
  GET_PROFILE,
  UPDATE_PROFILE,
  GET_EMPLOYEES,
  UPDATE_EMPLOYEE,
  CREATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  GET_ALL_SERVICES,
  GET_SERVICES,
  GET_SERVICE_BY_ID,
  CREATE_SERVICE,
  UPDATE_SERVICE,
  DELETE_SERVICE,
  GET_APPOINTMENTS,
  GET_EMPLOYEE_APPOINTMENTS,
  CREATE_APPOINTMENT,
  GET_CLIENTS,
  GET_CLIENT_HISTORY,
  GET_CLIENT_BY_ID,
  CREATE_CLIENT,
  GET_CLIENT_STATS,
  GET_TIMESLOTS,
  GET_SCHEDULE,
  CREATE_SCHEDULE,
  SEND_REMINDER,
  ADD_COMMENT,
  CANCEL_APPOINTMENT,
  DELETE_CLIENT,
  GET_ALL_PLANS,
  GET_USER_PLANS,
  ASSIGN_PLANS,
  FREEZE_UNFREEZE_PLAN,
  CANCEL_MEMBERSHIP,
  RENEW_SUBSCRIPTION_PLAN,
  RENEW_CARD_PLAN,
  DELETE_PLAN,
  CREATE_PLAN,
  SEND_POPUP,
  RESET_POPUP,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_TO_ALL,
  GET_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_COUNT,
  MARK_AS_READ_NOTIFICATIONS,
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTION_PLANS,
  GET_SUBSCRIPTION_PLAN_PRICE,
  SUBSCRIBE_TO_PLAN,
  CANCEL_SUBSCRIPTION,
  GET_INVOICES,
  SEND_INVOICES,
  GET_STATISTICS,
  GET_EMPLOYEE_APPOINTMENT_HISTORY,
  GET_PARTICIPANTS_OF_CLASS,
  MARK_ATTENDANCE,
  GET_WAITING_LIST_CLIENTS,
  REMOVE_FROM_WAITING_LIST,
  EXPORT,
  GET_COUPONS,
  CREATE_COUPON,
  COUPON_BY_ID,
  GET_COUPONS_USAGE_HISTORY,
  CHECK_SUBSCRIPTION,
  GET_GIFT_CARDS,
  CREATE_GIFT_CARD,
  GIFT_CARD_BY_ID,
  GET_GIFT_CARD_PURCHASE_HISTORY,
  GET_GIFT_CARD_CONSUMPTION_HISTORY,
  GET_GIFT_CARD_CONSUMPTION_HISTORY_BY_CODE,
  GET_FORMS,
  GET_FORM,
  CREATE_FORM,
  UPDATE_FORM,
  DELETE_FORM,
  TOGGLE_FORM,
  SEND_FORM_LINK,
  GET_FORM_SUBMISSIONS,
  GET_FORM_SUBMISSION,
  GET_FORM_LINKS,
  GET_CLIENT_FORM_LINKS,
  GET_FORM_SUBMISSION_PRINT,
  FORM_RESIGN_ALL,
  FORM_BULK_SEND,
  FORM_ALL_LINKS,
  FORM_SUBMISSION_NOTES,
  FORM_SUBMISSION_NOTE_DELETE,
  ASSETS_CREATE_SIGNED_UPLOAD_URL,
  ASSETS_SAVE_CLIENT_DOCUMENTS,
  ASSETS_GET_CLIENT_DOCUMENTS,
  ASSETS_DELETE_CLIENT_DOCUMENT,
  LIST_PAYMENT_REQUESTS,
  CREATE_PAYMENT_REQUEST,
  GET_PAYMENT_REQUEST,
  CANCEL_PAYMENT_REQUEST,
  RESEND_PAYMENT_REQUEST,
  GET_AUTOMATIONS,
  GET_TEMPLATES,
  CREATE_FROM_TEMPLATE,
  CREATE_AUTOMATION,
  UPDATE_AUTOMATION,
  DELETE_AUTOMATION,
  TOGGLE_AUTOMATION,
  GET_AUTOMATION_RUNS,
  GET_APPOINTMENT_REQUESTS,
  RESPOND_APPOINTMENT_REQUEST,
  GET_APPOINTMENT_REQUESTS_HISTORY,
  GET_SCHEDULE_OVERRIDES,
  CREATE_SCHEDULE_OVERRIDE,
  CREATE_SCHEDULE_OVERRIDE_RANGE,
  DELETE_SCHEDULE_OVERRIDE,
  CHECK_SCHEDULE_OVERRIDE_CONFLICTS,
  GET_SERVICE_CATEGORIES,
  CREATE_SERVICE_CATEGORY,
  GET_ALL_PRODUCTS,
  ADD_PRODUCT,
  EDIT_PRODUCT,
  DELETE_PRODUCT,
  PARSE_REMINDER,
  REMINDERS_LIST,
  REMINDERS_TRIGGERED,
  REMINDERS_CREATE,
  REMINDERS_UPDATE,
  REMINDERS_COMPLETE,
  REMINDERS_SNOOZE,
  REMINDERS_DELETE,
  GET_REVIEWS_MANAGE,
  GET_REVIEWS_STATS,
  TOGGLE_HIDE_REVIEW,
};
